import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { StatusLead } from '../interfaces/status-lead.interface';

@Injectable({
  providedIn: 'root'
})
export class StatusLeadService extends BaseApiService {

  private readonly cacheTime = 10 * 60 * 1000; // 10 min
  private statusSubject = new BehaviorSubject<StatusLead[] | null>(null);
  private lastFetchTime = 0;

  /** Retorna observable que sempre emite o estado atual */
  getAllList(): Observable<StatusLead[]> {
    const now = Date.now();

    // Se cache expirou ou ainda não foi carregado, refaz a consulta
    if (!this.statusSubject.value || (now - this.lastFetchTime) > this.cacheTime) {
      this.get<StatusLead[]>('/status-lead').subscribe({
        next: data => {
          this.lastFetchTime = now;
          this.statusSubject.next(data);
        },
        error: err => {
          console.error('Erro ao buscar status-lead', err);
          // opcional: manter último valor ou limpar
          this.statusSubject.next(null);
        }
      });
    }

    // Filtra para não emitir null
    return this.statusSubject.asObservable().pipe(
      filter((data): data is StatusLead[] => data !== null)
    );
  }

  refreshStatusList(): void {
    this.lastFetchTime = 0; // invalida cache
  }

}
